/**
 * English strings for the lead-list tour (PREC-3719 §8) — the six-stage
 * explanation flow reached from the nudge or the skip modal.
 */
export const enOnboardingTourListTour = {
	rail: "Platform tour",
	dummyTag: "Sample data",
	sampleListName: "Sample — Event attendees",
	sampleLoading: "Preparing your sample leads…",
	footer: {
		back: "Back",
		next: "Next",
		finish: "Got it, finish",
	},
	skip: {
		title: "Leave the tour?",
		body: "You can head back to finishing your setup, or keep looking around on your own.",
		continueSetup: "Continue with the setup",
		exploreOwn: "Explore on my own",
	},
	stages: {
		leadLists: {
			railTitle: "Your Lead Lists",
			title: "Your Lead Lists",
			body: "Lead Lists is where you organize everything. Create one in a click, bookmark your favourites, or just type what you want to do.",
			points: [
				"A list is Active (enriching or watching a signal) or Deactivated (stopped).",
				"Its campaigns can be running or paused — shown separately from enrichment.",
				"One list can hold multiple sources of the same type (several files, several LinkedIn keywords).",
				"A list can have several campaigns, but each campaign belongs to one list.",
				"Click a list name to open it and start reaching out.",
			],
		},
		workingInLists: {
			railTitle: "Working in lead lists",
			title: "Working in lead lists",
			body: "Inside a list, leads move through a simple workflow across the top tabs — and you can act on them one by one or in bulk.",
			points: [
				"New — freshly found leads.",
				"To be reviewed — saved for a closer look.",
				"Assigned — leads you've started reaching out to.",
				"Ignored — anything not assigned & contacted within 30 days moves here automatically.",
				"Select several leads to add to a campaign, export, change status, enrich or snooze in one go.",
			],
		},
		enrichmentBuckets: {
			railTitle: "Found · Unsure · Not found",
			title: "Found · Unsure · Not found",
			body: "When we enrich attendees, file rows, or people at target companies, each lead lands in one of three buckets.",
			points: [
				"Found — we have at least a LinkedIn profile or an email.",
				"Unsure — something's off (left the company, or works somewhere other than we searched). See the Exclusion reason column.",
				"Not found — no company, no person, or no way to reach them. You can still add an email or LinkedIn URL by hand.",
			],
		},
		scoringInAction: {
			railTitle: "Lead Scoring in action",
			title: "Lead Scores, net-new leads and existing contacts",
			body: "Every lead carries a P1 / P2 / P3 / DQ badge — the result of your Lead Scoring. Hover a badge for the reasoning; change it to teach Signalist over time. The coloured dot next to each lead shows their outreach history.",
			points: [
				"Blue — you or a teammate is connected on LinkedIn.",
				"Green — net-new, never contacted through Signalist.",
				"Grey — on a previous list, but never contacted.",
				"Yellow — was in a past outreach campaign.",
				"Red — in an active campaign right now — beware!",
			],
			foot: "This helps you triage which net-new leads to add to campaigns and which to reach out to by hand.",
		},
		outreach: {
			railTitle: "Outreach",
			title: "Reach out with or without AI, in a multi-channel campaign or manually",
			body: "Open the Reach out menu on any lead — pick per lead or in bulk.",
			points: [
				"Add to campaign — drop them into a multi-step sequence.",
				"Review & edit campaign — review the lead and choose which campaign to add to.",
				"Let AI write a sequence — a 3-step LinkedIn + email sequence you review, edit and send from the Lead Panel.",
				"Write manually — use templates and snippets, and schedule follow-ups.",
			],
		},
		campaignBuilder: {
			railTitle: "Building a campaign",
			title: "Building a campaign",
			body: "From a list, Create a campaign opens a visual sequence builder. Add a step and you can freely mix channels and logic in one flow.",
			points: [
				"LinkedIn actions — profile visit, invite, message, or InMail.",
				"Email actions — send an email message (once the lead has an enriched email).",
				"Conditions — branch on whether a lead is connected, has an email or LinkedIn, or by priority.",
				"Steps run in order; if one can't run, the next takes over — and the sequence stops the moment a lead replies.",
				"Personalize with variables, AI Snippets, and Spintax — we'll walk you through it when you get there.",
			],
		},
	},
};
